import React from "react";


interface Props {
  refreshKey: string
  customMessage?: string
}


export const SavedMessage: React.FC<Props> = props => {

  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (props.refreshKey) {
      setShow(true);
      setTimeout(() => { setShow(false); }, 5000);
    }
  }, [props.refreshKey]);

  if (show) return <div className="alert alert-success" role="alert">{props.customMessage || "Changes Saved"}</div>
  else return null;
}

